<template>
  <div class="container-full" :style="`background-image:url('${urlImage}');`">
    <div class="container-info">
      <div class="title-container">
        <h1 class="title">{{ title }}</h1>
        <h2 class="subtitle">{{ subtitle }}</h2>
      </div>
      <div class="boton-contactanos" v-if="showBoton" @click="$router.push({name:'registrate'})">
        Quiero Contactar con Quality & Care
      </div>
     </div>
  </div>
</template>

<script>
export default {
  name:"Jumbotron",
  props:{
    title: {
      type: String,
      default: 'Quality & Care'
    },
    subtitle: {
      type: String,
      default: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Quisquam, quos.'
    },
    urlImage: {
      type: String,
      default: ',../../assets/layout/images/fondo_banner.png'
    },
    showBoton: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style scoped>
.container-full{
  display: flex;
  width: 100%;  
  height: 450px;      
  background-size: auto;
  background-position-y: center; 
  align-items: center;
  justify-content: center;
  user-select: none;
}

.container-info{
  width: 80%;
  height: 80%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
}

.title-container{
  display: flex;
  flex-direction: column;
  background-color: #041A42;
  color: #ffffff;
  width: 40%;
  padding: 30px;  
}

.title{  
  margin: 0px;
  font-size: 30px;
}
.subtitle{  
  margin: 0px;
  padding-top: 10px;  
  font-size: 18px;
  line-height: 26px;
}

.boton-contactanos{
  display: flex;  
  align-items: center;
  justify-content: center;
  width: 300px;
  height: 41px;
  background-color: #2B86D9;
  color: #ffffff;  
  font-size: 14px;  
  line-height: 21px;
  border-radius: 9999px;  
  margin-top:30px;
  cursor: pointer;
}

@media screen and (max-width: 1500px) {
  .title-container{
    width: 60%;
  }
}

@media screen and (max-width: 1130px) {
  .title-container{
    width: 80%;
  }
}

@media screen and (max-width: 810px) {
  .title-container{
    width: 90%;
  }
}

@media screen and (max-width: 650px) {
  .title-container{
    width: 100%;
  }
}
</style>